import {
  AUTH_LOGOUT,
  AUTH_PROFILE_UPDATE,
  AUTH_TOKEN_SET,
  ON_APPLICATION_ERROR,
  SIGNIN_USER_REQUEST,
  USER_ATTETION_VIEWED,
  USER_LOGIN_PAGE_MODAL_VIEWED,
  USER_PERMISSIONS_SET,
} from 'actions/types'

import { createReducer } from '../utils'

const initialState = () => {
  return {
    isAuthenticated: false,
    token: null,
    profile: {},
    fetchingToken: false,
    role: {},
    attentionShowed: false,
    loginPageModalShowed: false,
    requirePwChange: false,
    warningPwChange: false,
  }
}

export const auth = createReducer(initialState(), {
  [SIGNIN_USER_REQUEST]: (state: any) => ({ ...state, fetchingToken: true }),
  [ON_APPLICATION_ERROR]: (state: any) => ({ ...state, fetchingToken: false }),
  [AUTH_TOKEN_SET]: (state: any, payload: any) => {
    const { token, user: profile, requirePwChange, warningPwChange } = payload
    return {
      ...state,
      isAuthenticated: true,
      token,
      profile,
      fetchingToken: false,
      attentionShowed: false,
      loginPageModalShowed: false,
      requirePwChange,
      warningPwChange,
    }
  },
  [AUTH_PROFILE_UPDATE]: (state: any, payload: any) => {
    return {
      ...state,
      profile: {
        ...state.profile,
        ...payload.profile,
      },
    }
  },
  [USER_PERMISSIONS_SET]: (state: any, payload: any) => {
    const { role } = payload
    return {
      ...state,
      role,
    }
  },
  [USER_ATTETION_VIEWED]: (state: any) => {
    return {
      ...state,
      attentionShowed: true,
    }
  },
  [USER_LOGIN_PAGE_MODAL_VIEWED]: (state: any) => {
    return {
      ...state,
      loginPageModalShowed: true,
    }
  },
  [AUTH_LOGOUT]: () => initialState(),
})
